export * from './lib/bottom-bar.service';
export * from './lib/bottom-bar.animations';
